import React from 'react';
import {Switch, Route} from "react-router-dom";
import Home from '../pages/Home';
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import PasswordReset from '../pages/PasswordReset';
import PasswordUpdate from '../pages/PasswordUpdate';
import ReactGA from 'react-ga';
import Plaudy from "plaudy";
import AutoLogin from "../pages/AutoLogin";
import Share from "../pages/Share";

const Routes = () => {
  const updateGoogleAnalytics = ({location}) => {
    ReactGA.pageview(location.pathname + location.search);
    Plaudy.track('visit', {
      url: location.pathname + location.search,
      path: location.pathname,
    });
    return null;
  };

  return (
    <>
      <Route path="/" render={updateGoogleAnalytics}/>
      <Switch>
        <Route exact path="/login" component={Login}/>
        <Route path="/login/:token" component={AutoLogin}/>
        <Route path="/signup" component={Signup}/>
        <Route path="/password-reset" component={PasswordReset}/>
        <Route path="/password-update" component={PasswordUpdate}/>
        <Route path="/share/:shareUrl" component={Share}/>
        <Route path="/:folder" component={Home}/>
        <Route path="/" component={Home}/>
      </Switch>
    </>
  );
};

export default Routes;
